import { stringify } from 'query-string';
import { apiCreate, apiGetOne } from './ApiBaseActions';
export const API_CREATE_PROFFIT_SEARCH_TRIAL_INVITE = 'API_CREATE_PROFFIT_SEARCH_TRIAL_INVITE';
export const API_CREATE_PROFFIT_SEARCH_TRIAL_STATUS_INVITE = 'API_CREATE_PROFFIT_SEARCH_TRIAL_STATUS_INVITE';
/**
 * トライアルへの招待
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiCreateProffitSearchTrialInvite = (params, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_TRIAL_INVITE, '/proffit_search/trial', params, meta || {});
/**
 * トライアルへの招待が可能か確認する
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: {cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetProffitSearchTrialInviteStatus = (params, meta) => apiGetOne(API_CREATE_PROFFIT_SEARCH_TRIAL_STATUS_INVITE, `/proffit_search/trial_status?${stringify(params)}`, meta || {});
